import { createFileRoute } from '@tanstack/react-router';
import { ServiceProvidersCard } from './-components/ServiceProvidersCard';

export const Route = createFileRoute('/_auth/dashboard/_layout/service-providers')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Service Providers - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  return <ServiceProvidersCard />;
}
